import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { loadLocales } from './utils/localeLoader';



const initializeI18n = async (appId) => {
    try {
        const { en, ar } = await loadLocales(appId);

        const savedLanguage = localStorage.getItem('selectedLanguage') || 'en'; // Use saved language




        i18n.use(initReactI18next).init({
            resources: {
                en: { translation: en.default },
                ar: { translation: ar.default },
            },
            lng: savedLanguage, // Load saved language
            fallbackLng: 'en',
            interpolation: { escapeValue: false },
        });
    } catch (error) {
        console.error('Failed to initialize i18n:', error);
    }
};

export default initializeI18n;
